import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';

const WelcomeCard = styled.div`
    background: linear-gradient(
        135deg,
        ${({ theme }) => theme?.colors?.primary?.main || '#667eea'} 0%,
        ${({ theme }) => theme?.colors?.primary?.dark || '#5568d3'} 100%
    );
    color: white;
    padding: clamp(24px, 5vw, 40px);
    border-radius: 16px;
    margin-bottom: clamp(20px, 3vw, 28px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
    font-size: clamp(1.375rem, 4vw, 1.875rem);
    font-weight: 600;
    margin-bottom: 8px;
    line-height: 1.2;
    word-break: break-word;
`;

const Subtitle = styled.p`
    font-size: clamp(0.95rem, 2.5vw, 1.05rem);
    opacity: 0.92;
    line-height: 1.45;
    margin: 0;
`;

const InfoCard = styled.div`
    background: white;
    padding: clamp(20px, 4vw, 28px);
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid ${({ theme }) => theme?.colors?.gray?.[200] || '#e2e8f0'};
    margin-top: 8px;
`;

const InfoTitle = styled.h2`
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme?.colors?.gray?.[900] || '#1a202c'};
    margin-bottom: 12px;
`;

const InfoText = styled.p`
    font-size: 15px;
    line-height: 1.6;
    color: ${({ theme }) => theme?.colors?.gray?.[700] || '#4a5568'};
    margin-bottom: 10px;
`;

/**
 * @param {{ showQuickAccess?: boolean }} props
 */
export default function DashboardWelcome({ showQuickAccess = true }) {
    const { user } = useAuth();

    return (
        <>
            <WelcomeCard>
                <Title>Bem-vindo, {user?.name || 'Usuário'}!</Title>
                <Subtitle>
                    {showQuickAccess
                        ? 'Use o menu lateral para navegar pelas seções disponíveis na sua conta.'
                        : 'Acompanhe suas entregas e indicadores operacionais do período.'}
                </Subtitle>
            </WelcomeCard>
            {showQuickAccess ? (
                <InfoCard>
                    <InfoTitle>Acesso rápido</InfoTitle>
                    <InfoText>Use o menu lateral para entregas, colaboradores, veículos e relatórios.</InfoText>
                </InfoCard>
            ) : null}
        </>
    );
}
